(function () {
  'use strict';

  angular.module('dashboard.lead.working', ['ngResource']);
})();
